import { Pipe, PipeTransform, OnDestroy } from '@angular/core';
import { interval, Subscription } from 'rxjs';

@Pipe({
  standalone: true,
  name: 'elapsedTime',
  pure: false // Make the pipe impure to allow updates
})
export class ElapsedTimePipe implements PipeTransform, OnDestroy {
  private timer: Subscription | null = null;

  transform(value: Date | string): string {
    if (!value) return '';

    // Clear any existing timer
    this.removeTimer();

    // Start a new timer that updates every second
    this.timer = interval(1000).subscribe(() => {
      // Force change detection
      this.getTimeString(value);
    });

    return this.getTimeString(value);
  }

  private getTimeString(value: Date | string): string {
    const inputDate = new Date(value);
    const now = new Date();

    const diff = Math.floor((now.getTime() - inputDate.getTime()) / 1000); // difference in seconds

    const hours = Math.floor(diff / 3600);
    const minutes = Math.floor((diff % 3600) / 60);
    const seconds = diff % 60;

    return `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  private removeTimer() {
    if (this.timer) {
      this.timer.unsubscribe();
      this.timer = null;
    }
  }

  ngOnDestroy() {
    this.removeTimer();
  }
}
